const PRIVACY_ACCEPTED_FOR_KEY = 'privacyAcceptedFor'

/**
 * The Keycloak login session the user's token belongs to.
 *
 * Keycloak 25+ no longer puts `session_state` in tokens; `sid` carries the same
 * value. `session_state` is kept as a fallback for tokens that still have it.
 */
export function sessionIdFromUser (user) {
  if (!user) return undefined
  return user.sid || user.session_state
}

export function isPrivacyAcceptedFor (sessionId) {
  if (!sessionId) return false
  return localStorage.getItem(PRIVACY_ACCEPTED_FOR_KEY) === sessionId
}

export function markPrivacyAcceptedFor (sessionId) {
  if (!sessionId) return
  localStorage.setItem(PRIVACY_ACCEPTED_FOR_KEY, sessionId)
}
